<ndt-user-password-reset-request-view
   (passwordResetRequest)="onUserPasswordResetRequest($event)"
   [loading]="callState | async"
   (formCanceled)="onCloseClick()"
>
</ndt-user-password-reset-request-view>
